<template>
  <div class="text-block">
    <h2 v-html="title" />
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TextBlock',
  props: ['title'],
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  .text-block
    max-width: 65rem
    margin: 5rem auto 10rem auto
    padding: 0 2.5rem

    h2
      margin-bottom: 4rem
      text-align: center

</style>
